// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__G349C","wrapperBottom":"styles_wrapperBottom__6uWJd","dateTime":"styles_dateTime__HaVcB","text":"styles_text__DRZa1"};